<ndt-extension-detail-link
   [extension]="extensionFmFm?.extension"
   [header]="'Find Me Follow Me Extension'"
></ndt-extension-detail-link>
<ndt-extension-detail-link
   [extension]="extensionFmFm?.finalDestinationExtension"
   [header]="'Final Destination Extension'"
></ndt-extension-detail-link>
